export default __webpack_public_path__ + "static/media/dentin.902818da.svg";